import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "menu-point-list list-unstyled"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_menu_point_line = _resolveComponent("menu-point-line");
  return _openBlock(), _createElementBlock("ul", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.modelValue, (menuPoint, mpk) => {
    return _openBlock(), _createBlock(_component_menu_point_line, {
      key: mpk,
      modelValue: menuPoint,
      "onUpdate:modelValue": value => $options.updateModelValue(value, mpk),
      valueProperty: $props.valueProperty
    }, null, 8, ["modelValue", "onUpdate:modelValue", "valueProperty"]);
  }), 128))]);
}